import { createSlice } from '@reduxjs/toolkit';
import {
  fetchMeetingsThunk,
  fetchMeetingThunk,
  createMeetingThunk,
  updateMeetingThunk,
  deleteMeetingThunk,
} from './teamMeetingsActionThunks';

const initialState = {
  items: [],
  detailById: {},
  loading: { items: false, detail: false, mutate: false },
  errors: { items: null, detail: null, mutate: null },
};

const teamMeetingsSlice = createSlice({
  name: 'teamMeetings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // === List ===
      .addCase(fetchMeetingsThunk.pending, (state) => {
        state.loading.items = true;
        state.errors.items = null;
      })
      .addCase(fetchMeetingsThunk.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading.items = false;
      })
      .addCase(fetchMeetingsThunk.rejected, (state, action) => {
        state.loading.items = false;
        state.errors.items = action.payload || 'Failed to load meetings';
      })

      // === Detail ===
      .addCase(fetchMeetingThunk.pending, (state) => {
        state.loading.detail = true;
        state.errors.detail = null;
      })
      .addCase(fetchMeetingThunk.fulfilled, (state, action) => {
        state.loading.detail = false;
        state.detailById[action.payload.id] = action.payload;
      })
      .addCase(fetchMeetingThunk.rejected, (state, action) => {
        state.loading.detail = false;
        state.errors.detail = action.payload || 'Failed to load meeting';
      })

      // === Create ===
      .addCase(createMeetingThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(createMeetingThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        state.items.unshift(action.payload);
        state.detailById[action.payload.id] = action.payload;
      })
      .addCase(createMeetingThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to create meeting';
      })

      // === Update ===
      .addCase(updateMeetingThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(updateMeetingThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        state.detailById[action.payload.id] = action.payload;
        const idx = state.items.findIndex((i) => i.id === action.payload.id);
        if (idx !== -1) state.items[idx] = { ...state.items[idx], ...action.payload };
      })
      .addCase(updateMeetingThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to update meeting';
      })

      // === Delete ===
      .addCase(deleteMeetingThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(deleteMeetingThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        state.items = state.items.filter((i) => i.id !== action.payload);
        delete state.detailById[action.payload];
      })
      .addCase(deleteMeetingThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to delete meeting';
      });
  },
});

export default teamMeetingsSlice.reducer;
